export const DashboardFilteresTypes = Object.freeze({
  DiscountRedemptions: "Discount Redemptions",
  DiscountsGranted: "Discounts Granted",
  CreditRedeemed: "Credit Redeemed",
  CreditGranted: "Credit Granted",
  ContactsWelcomed: "Contacts Welcomed",
  DiscountsExpiredWithoutRedemption: "Discounts Expired Without Redemption",
});


export const SU_DashboardFilteresTypes = Object.freeze({
  DiscountsRedeemed: "Discounts Redeemed",
  CreditRedeemed: "Credit Redeemed",
  CreditActivated: "Credit Activated",
  DiscountsActivated: "Discounts Activated",
});

export const DashboardFiltersSubTypes = Object.freeze({
  New: "New Customers",
  Returning: "Returning Customers",
  Referrers: "Referrers",
});
